import { ServiceTransitionActions } from "../action";

export type ServiceTransitionError = {
  title: string;
  message: string;
};

type ServiceTransitionState = {
  errorMessageContent?: ServiceTransitionError;
  declineType?: string;
  serviceType?: string;
};

export default function (state: ServiceTransitionState = {}, action: ServiceTransitionActions): ServiceTransitionState {
  switch (action.type) {
    case "UPDATE_SERVICE_TRANSITION":
      return { ...state, ...action.payload };
    case "REFRESH_REDUCERS":
      return {};
    default:
      return state;
  }
}
